import { render, staticRenderFns } from "./DimensionDivision.vue?vue&type=template&id=1fee77fc&scoped=true&"
import script from "./DimensionDivision.vue?vue&type=script&lang=js&"
export * from "./DimensionDivision.vue?vue&type=script&lang=js&"
import style0 from "./DimensionDivision.vue?vue&type=style&index=0&id=1fee77fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fee77fc",
  null
  
)

export default component.exports